import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Layout from '../Layout';
import { colors } from '../../constants/styleConstants';
import FbPagination from '../FbPagination';
import ScrollToTop from '../ScrollToTop';
import H1 from '../H1';

const useStyles = makeStyles(theme => ({
  toolBar: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
  },
  header: {
    padding: '20px 30px 15px',
    [theme.breakpoints.down('xs')]: {
      padding: '16px',
    },
  },
  proHeader: {
    background: colors.lightPrimary,
  },
  headerWrapper: {
    marginBottom: 10,
  },
  mainTitle: {
    display: 'inline-flex',
    fontSize: '55px',
    fontWeight: 400,
    margin: 0,
    lineHeight: 1.1,
    color: colors.primaryTitleColor,
    marginRight: theme.spacing(2),
  },
  subTitle: {
    fontSize: '20px',
    display: 'inline-block',
    [theme.breakpoints.down('sm')]: {
      lineHeight: 1.2,
      margin: '10px 0 15px',
    },
  },
  searchFiltersWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
  },
  searchWrapper: {
    justifyContent: 'flex-end',
  },
  contentDivider: {
    background: colors.contentDivider,
    height: '1px',
    width: '100%',
  },
  content: {
    padding: '0 30px',
    [theme.breakpoints.down('xs')]: {
      padding: '0 16px',
    },
  },
}));

const ListingPageLayout = ({
  BackToLinkSection,
  content,
  customBreadcrumbs,
  searchFiltersComponent,
  title,
  subTitle,
  contentDivider,
  pagination,
  sortingForm,
  proLabel,
  seo,
  contentClassName,
  isHeaderControlled,
  overrideClasses = {},
}) => {
  const classes = useStyles();
  const { header, searchFiltersWrapper } = overrideClasses;

  return (
    <Layout title={title} customBreadcrumbs={customBreadcrumbs} seo={seo}>
      <div className={classnames(classes.header, header, { [classes.proHeader]: proLabel })}>
        {BackToLinkSection && <div className={classes.toolBar}>{BackToLinkSection && <BackToLinkSection />}</div>}
        {!isHeaderControlled && (
          <div className={classes.headerWrapper}>
            <H1 className={classes.mainTitle}>
              {title}
              {proLabel && proLabel}
            </H1>
            <div className={classes.subTitle}>{subTitle}</div>
          </div>
        )}
        <div className={classnames(classes.searchFiltersWrapper, searchFiltersWrapper)}>
          {searchFiltersComponent && searchFiltersComponent}
        </div>
      </div>
      {contentDivider && <div className={classes.contentDivider} />}
      {sortingForm && sortingForm}
      <div className={classnames(classes.content, contentClassName)}>{content && content}</div>
      {pagination && <FbPagination {...pagination} />}
      <ScrollToTop />
    </Layout>
  );
};

ListingPageLayout.propTypes = {
  BackToLinkSection: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  customBreadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  searchFiltersComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  contentDivider: PropTypes.bool,
  pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape(FbPagination.propTypes)]),
  sortingForm: PropTypes.node,
  contentClassName: PropTypes.string,
  isHeaderControlled: PropTypes.bool,
};

ListingPageLayout.defaultProps = {
  contentDivider: true,
  contentClassName: '',
  isHeaderControlled: false,
};

export default ListingPageLayout;
